// extracted by mini-css-extract-plugin
export default {"CarImgSlider":"CarImgSlider_CarImgSlider__fb69x","imgSlider":"CarImgSlider_imgSlider__aaomr","sold":"CarImgSlider_sold__ovmLK","reserved":"CarImgSlider_reserved__9Po-E"};